import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/w/$workspaceId")({
  component: PraxaWorkspaceRoute,
});

function PraxaWorkspaceRoute() {
  return <Outlet />;
}
